import { useState } from 'react';
import { Image, Text, Slider, ButtonBase } from '@belong/ui';
import PropTypes from 'prop-types';
import { POST_INSPECTION_FLOW_STRINGS } from 'strings/post-inspection-flow';
import PostInspectionContentLayout from '../../../PostInspectionContentLayout/PostInspectionContentLayout';
import { getPricingAssignedEmployee } from '../utils';
import css from './TheMarket.module.css';

const priceImage = {
  1: '/pricing-flow/pricing_under.png',
  2: '/pricing-flow/pricing_optimal.png',
  3: '/pricing-flow/pricing_over.png',
};

const TheMarket = ({
  stepConfigs,
  stepConfig,
  onSaveAndNext,
  stepResource,
  onPrevious: _onPrevious,
}) => {
  const [price, setPrice] = useState(2);

  const assignedEmployee = getPricingAssignedEmployee(stepResource);

  return (
    <PostInspectionContentLayout
      showCityBackground={false}
      noOverlay
      stepConfigs={stepConfigs}
      stepConfig={stepConfig}
      employee={assignedEmployee}
      title={POST_INSPECTION_FLOW_STRINGS['the_market.title']}
    >
      <Text variant="h3" fontWeight="semibold" className="mb-xs">
        {POST_INSPECTION_FLOW_STRINGS['the_market.grap.title']}
      </Text>
      <Text className="mb-2xl">
        {POST_INSPECTION_FLOW_STRINGS['the_market.grap.subtitle']}
      </Text>
      <div className="mb-md" style={{ height: 340 }}>
        <Image src={priceImage[price]} alt="" style={{ overflow: 'unset' }} />
      </div>
      <div className="mb-sm flex w-full flex-col items-center">
        <Text variant="p1" fontWeight="semibold">
          Optimal Price
        </Text>
        <div className="flex w-full flex-row items-center justify-center gap-lg px-0 py-lg lg:px-3xl">
          <Text fontWeight="semibold">Low</Text>
          <div className="w-full">
            <Slider
              min={1}
              max={3}
              step={1}
              value={price}
              onChange={(val) => setPrice(val)}
              variant="gradient-red-to-green-to-red"
              orientation="horizontal"
            />
          </div>
          <Text fontWeight="semibold">High</Text>
        </div>
      </div>
      <div className="mb-3xl hidden justify-center md:flex">
        <PostInspectionContentLayout.CtaButton onClick={() => onSaveAndNext()}>
          {POST_INSPECTION_FLOW_STRINGS['the_market.button_text']}
        </PostInspectionContentLayout.CtaButton>
      </div>
      <div className="mx-auto w-fit">
        <Text variant="h3" fontWeight="semibold" className="mb-sm">
          {POST_INSPECTION_FLOW_STRINGS['the_market.section.other_factors']}
        </Text>

        <div className="grid grid-cols-1 gap-y-sm lg:grid-cols-4">
          <div className="flex flex-col items-center">
            <div className={css.iconContainer}>
              <Image src="/pricing-flow/pricing_seasonality.png" alt="" />
            </div>
            <Text fontWeight="semibold" className="mt-xs">
              Seasonality
            </Text>
          </div>
          <div className="flex flex-col items-center">
            <div className={css.iconContainer}>
              <Image src="/pricing-flow/pricing_location.png" alt="" />
            </div>
            <Text fontWeight="semibold" className="mt-xs">
              Location
            </Text>
          </div>
          <div className="flex flex-col items-center">
            <div className={css.iconContainer}>
              <Image src="/pricing-flow/pricing_pets.png" alt="" />
            </div>
            <Text fontWeight="semibold" className="mt-xs">
              Allowing Pets
            </Text>
          </div>
          <div className="flex flex-col items-center">
            <div className={css.iconContainer}>
              <Image src="/pricing-flow/pricing_home.png" alt="" />
            </div>
            <Text fontWeight="semibold" className="mt-xs">
              Home Condition
            </Text>
          </div>
        </div>
      </div>
      <div className="my-2xl flex w-full md:hidden">
        <ButtonBase
          className="rounded h-2xl flex-1 bg-green disabled:bg-gray"
          onClick={() => onSaveAndNext()}
        >
          <Text fontWeight="semibold" className="text-white">
            Next
          </Text>
        </ButtonBase>
      </div>
    </PostInspectionContentLayout>
  );
};

TheMarket.propTypes = {
  onSaveAndNext: PropTypes.func.isRequired,
  onPrevious: PropTypes.func.isRequired,
  stepConfigs: PropTypes.arrayOf(PropTypes.object).isRequired,
  stepConfig: PropTypes.object.isRequired,
  stepResource: {
    employeeAssignments: PropTypes.array.isRequired,
  },
};

export default TheMarket;
